import { NextRouter } from 'next/router';

export function appendQueryParams(router: NextRouter, params: URLSearchParams, replace: string[] = [], shallow = true) {
  const currentParamsEntries = Object.entries(router.query).filter(([key]) => !replace.includes(key));

  router.push({ query: { ...Object.fromEntries(currentParamsEntries), ...Object.fromEntries(params.entries()) } }, undefined, {
    shallow,
  });
}

/**
 * Constructs a query string from an object of parameters.
 * @param params - The parameters to be converted into a query string.
 * @returns The query string.
 */
export const queryParamsFromObj = (params: any) =>
  Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');

/**
 * Appends the host or testHost query parameter to the URL if isCheckHost is true.
 * @param url - The URL to which the host or testHost parameter will be appended.
 * @param isCheckHost - A flag indicating whether to append the host or testHost parameter.
 * @returns The modified URL.
 */
export const getUrlWithHost = (url: string, isCheckHost: boolean) => {
  if (!isCheckHost) return url;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const testHost = urlSearchParams.get('testHost');
  const host = urlSearchParams.get('host');
  if (testHost) {
    return `${url}?testHost=${testHost}`;
  }
  return url;
};

/**
 * Removes the http or https protocol from a URL.
 * @param url - The URL from which the protocol will be removed.
 * @returns The URL without the protocol.
 */
export const removeHttpFromUrl = (url: string) => {
  if (url.startsWith('https://') || url.startsWith('http://')) {
    let newUrl = url.replace(/^https?:\/\//, '');
    return newUrl.replace(/^http?:\/\//, '');
  }
  return url;
};

export function getLoginPath(withRedirect = false) {
  const LOGIN_PATH = '/login';

  return LOGIN_PATH;
  // We are not using redirection for now
  // const { pathname, search } = window.location;
  // const currentPath = `${pathname}${search}`;

  // if (currentPath === LOGIN_PATH) {
  //   return LOGIN_PATH;
  // }

  // return `${LOGIN_PATH}?redirect=${encodeURI(currentPath)}`;
}
